import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { IssueNoteEntity } from './issue-note.entity';
import { IssueEntity } from './issue.entity';

@Index('issue__file__fk__file__id_fk', ['fkFileId'], {})
@Index('issue__file__fk_issue__id_fk', ['fkIssueId'], {})
@Index('IDX_issue__file_note', ['fkIssueNoteId'], {})
@Entity('issue__file')
export class IssueFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_issue__id', unsigned: true })
	public fkIssueId!: number;

	// PD-16475 — the note (or portal message) an image was sent with. NULL for
	// a file on the issue itself (the description, or the Files tab).
	@Column('int', { name: 'fk_issue_note__id', nullable: true, unsigned: true })
	public fkIssueNoteId!: number | null;

	@ManyToOne(() => IssueNoteEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_issue_note__id', referencedColumnName: 'id' }])
	public fkIssueNote!: IssueNoteEntity | null;

	// PD-16475 — whether the customer who submitted the issue can see this
	// file in the storefront. Customer uploads and files on a note shared with
	// the customer are visible; everything else stays internal.
	@Column('tinyint', { name: 'isPortalVisible', width: 1, default: 0 })
	public isPortalVisible!: boolean;

	@ManyToOne(() => IssueEntity, (issue) => issue.issueFiles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_issue__id', referencedColumnName: 'id' }])
	public fkIssue!: IssueEntity;

	@ManyToOne(() => FileEntity, (file) => file.issueFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
